import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStepper } from '@angular/material/stepper';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { UserProcessListQuestionDialogComponent } from '../user-process-list-question-dialog/user-process-list-question-dialog.component';
import { OneSignalService } from 'src/services/onesignal.service';
import { CommunicationService } from 'src/services/communication.service';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import ptBrLocale from '@fullcalendar/core/locales/pt-br';
import { CalendarOptions, EventClickArg } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import { UserProcessListInterviewDialogComponent } from '../user-process-list-interview-dialog/user-process-list-interview-dialog.component';
import { FullCalendarComponent } from '@fullcalendar/angular';

@Component({
  selector: 'app-user-process-list-dialog',
  templateUrl: './user-process-list-dialog.component.html',
  styleUrls: ['./user-process-list-dialog.component.scss']
})
export class UserProcessListDialogComponent implements OnInit {

  form: FormGroup;
  currentProcessList: any;
  tests: Array<any> = [];
  questionsPunctuation = {};
  interviews: Array<any>;
  isSmallScreen$: Observable<boolean>;
  showInterview: boolean = false;
  submiting: boolean = false;
  showinfo: boolean = false;
  @ViewChild('interviewStepper', { static: false }) interviewStepper: MatStepper
  @ViewChild('fullcalendar') calendarComponent!: FullCalendarComponent;
  events: any[] = [];
  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth',
    plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
    locale: ptBrLocale,
    eventClick: this.handleEventClick.bind(this),
    eventContent: (arg) => {
      const tipo = arg.event.extendedProps.tipo;
      const borderColor = tipo === 'Remota' ? '#4caf50' : '#3f51b5'; // verde ou azul
      const backgroundColor = tipo === 'Remota' ? '#e8f5e9' : '#f0f4ff'; // verde claro ou azul claro
      const data = arg.event.start;
      const horario = data?.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      const dia = data?.toLocaleDateString('pt-BR');

      return {
        html: `
          <div style="
            background-color: ${backgroundColor};  
            border-left: 4px solid ${borderColor};
            padding: 4px 6px;
            border-radius: 4px;
            font-size: 12px;
            color: #333;
            font-weight: 500;
            box-shadow: 0 1px 2px rgba(0,0,0,0.1);
            line-height: 1.2;
            cursor:pointer;
          ">
            <small>${dia} às ${horario}</small><br/>
            ${arg.event.title}<br/>
            <span style="font-size: 11px; color: #666;">${tipo}</span>
          </div>
        `
      };
    }
  };

  constructor(
    private breakpoint: BreakpointObserver,
    private http: HttpService,
    private errorReport: ErrorReportService,
    private dialog: MatDialog,
    private snackbar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) data: any,
    private fb: FormBuilder,
    private oneSignalService: OneSignalService,
    private communicationService: CommunicationService,
  ) { 
    this.currentProcessList = data;
    // console.log('PROCCESS', this.currentProcessList);
    // setTimeout(() => {      
    //   if(data.pendingInterview > 0)
    //     this.interviewStepper.next();
    // }, 500)

    if (this.currentProcessList.sinonimo && this.currentProcessList.salary) {
      
      this.showinfo = true;

      this.form = this.fb.group({
        companyname: [this.currentProcessList.companyname],
        phone:[this.currentProcessList.phone],
        zipCode: [this.currentProcessList.zipCode],
        state: [this.currentProcessList.state],
        city: [this.currentProcessList.city],
        district: [this.currentProcessList.district],
        street: [this.currentProcessList.street],
        number: [this.currentProcessList.number],
        complement: [this.currentProcessList.complement],
        modalityjob: [this.currentProcessList.modalityjob],
        sinonimo: [this.currentProcessList.sinonimo],
        salary: [(this.currentProcessList.salary === '0000') ? 'à combinar' : this.formatSalaryForEdit(this.currentProcessList.salary)],
        coin: [this.currentProcessList.coin],
        workregime: [this.currentProcessList.workregime],
        daysWeek: [this.getDiasSemana(this.currentProcessList.daysWeek)],
        start_monday: [this.formatarHora(this.currentProcessList.start_monday)],
        end_monday: [this.formatarHora(this.currentProcessList.end_monday)],
        start_tuesday: [this.formatarHora(this.currentProcessList.start_tuesday)],
        end_tuesday: [this.formatarHora(this.currentProcessList.end_tuesday)],
        start_wednesday: [this.formatarHora(this.currentProcessList.start_wednesday)],
        end_wednesday: [this.formatarHora(this.currentProcessList.end_wednesday)],
        start_thursday: [this.formatarHora(this.currentProcessList.start_thursday)],
        end_thursday: [this.formatarHora(this.currentProcessList.end_thursday)],
        start_friday: [this.formatarHora(this.currentProcessList.start_friday)],
        end_friday: [this.formatarHora(this.currentProcessList.end_friday)],
        start_saturday: [this.formatarHora(this.currentProcessList.start_saturday)],
        end_saturday: [this.formatarHora(this.currentProcessList.end_saturday)],
        start_sunday: [this.formatarHora(this.currentProcessList.start_sunday)],
        end_sunday: [this.formatarHora(this.currentProcessList.end_sunday)],
        benefits: [this.currentProcessList.benefits],
        requirements: [this.currentProcessList.requirements],
        activities: [this.currentProcessList.activities],
      });

      
      if (this.currentProcessList.viewend !== 'true') {
        //console.log('VIEWEND TRUE');
        this.http.get('company', { id: this.currentProcessList.company })
          .subscribe(
            (result: any) => {
              if (result.type === 'OK') {
                let state = null;
                let city = null;

                if (result.data.companycity !== null) {
                  state = result.data.companycity.split(',')[2];
                  city = result.data.companycity.split(',')[0];
                }

                this.form.patchValue({
                  zipCode: result.data.companyzipcode,
                  state: result.data.companystate,
                  city: city,
                  district: result.data.district,
                  street: result.data.companyaddress1,
                  number: result.data.companyaddress2,
                  complement: result.data.complement,
                });
              }
            },
            err => this.errorReport.showMessage(err)
        );

      }

    }
  }

  ngOnInit(): void {
    this.isSmallScreen$ = this.breakpoint
      .observe([Breakpoints.XSmall, Breakpoints.HandsetPortrait])
      .pipe(
        map(state => {
          return state.matches
        })
      )

    const subject = new Subject();
    subject.subscribe(
      (result: any) => {

        const { trigger, scope } = result;          
        if(scope.indexOf('user_process_list:interview') > -1)
          this.submiting = trigger === 'pre';

      }
    )
    this.http.setLoadingIndicator(subject)

    this.getTest();
    this.getInterviews();
    this.acceptProcessList();  
  }

  acceptProcessList() {

    const user: any = JSON.parse(localStorage.getItem('token'));
    const data = {
      processListId: this.currentProcessList.id,
      userId: user.id
    }
    this.http.save('user_process_list:accept', data)
      .subscribe(
        result => { 
          //console.log(result) 
        },
        err => this.errorReport.showMessage(err)
      )

  }

  isCompletedTest() {
    return this.tests.length > 0 && this.tests.every(test => test.status !== 'pending')
  }

  isCompletedInterview() {
    return true;
  }

  getQuestionPunctuation(testId) {

    const user: any = JSON.parse(localStorage.getItem('token'));
    const params = { 
      test: testId,
      userId: user.id,
      processList: this.currentProcessList.id
    }
    
    this.http.list('user_process_list:question_punctuation', params)
      .subscribe(
        (result: any) => {
          this.questionsPunctuation[testId] = result.data
        },
        err => this.errorReport.showMessage(err)
      );

  }

  getTest() {

    const user: any = JSON.parse(localStorage.getItem('token'));
    const params = { 
      processList: this.currentProcessList.id,
      userId: user.id
    }
    
    this.http.list('user_process_list:test', params)
      .subscribe(
        (result: any) => {
          this.tests = result.data;
          for(const test of this.tests)
            this.getQuestionPunctuation(test.id);
        },
        err => this.errorReport.showMessage(err)
      );
  }

  openQuestions(test) {

    const user: any = JSON.parse(localStorage.getItem('token'));
    const options = {
      width: '800px',
      disableClose: true,
      data: { 
        test,
        userId: user.id,
        processList: this.currentProcessList,
        processListId: this.currentProcessList.id
      } 
    }
    this.dialog.open(UserProcessListQuestionDialogComponent, options)
      .afterClosed()
      .subscribe(
        result => {
          if(result)
            this.getTest();
        }
      );;
  }

  getTestStatus(status ) {

    if(status === 'pending')
      return 'Esperando sua resposta';

    if(status === 'answered')
      return 'Respondido, esperando avaliação';

    if(status === 'reject')
      return 'Rejeitado';

    if(status === 'evaluated')
      return 'Pontuação';

    if(status === 'approved')
      return 'Aprovado';

  }

  getInterviews() {    

    const user: any = JSON.parse(localStorage.getItem('token'));
    const params = {
      userId: user.id,
      processList: this.currentProcessList.id
    }
    this.http.list('user_process_list:interview', params)
      .subscribe(
        (result: any) => {
          this.interviews = result.data;
          if(this.interviews.length > 0){
            this.events = this.interviews.map((interview: any) => {
              const date = interview.date_start;
              const time = interview.time_start;
              const start = `${date}T${time}`;
            
              let backgroundColor = '';
              let textColor = '#fff';
              let title = `Entrevista para ${this.currentProcessList.name}`;
            
              if (interview.accept === 1) {
                backgroundColor = '#2196f3'; // azul
              } else if (interview.accept === 0) {
                backgroundColor = '#f44336'; // vermelho
              } else {
                backgroundColor = '#ff9800'; // laranja
                textColor = '#000';
                title = `⚠️ Confirmação pendente`;
              }
            
              return {
                title,
                start,
                end: this.addOneHour(start),
                backgroundColor,
                textColor,
                extendedProps: {
                  ...interview,
                  tipo: interview.type === 'true' ? 'Remota' : 'Presencial',
                  processo: this.currentProcessList.name,
                }
              };
            });

            if (this.events.length > 0) {
              setTimeout(() => {
                this.calendarComponent.getApi().gotoDate(this.events[0].start);
              });
            }
          }

        }
      )

  }

  /*getUserInterview() {

    const user: any = JSON.parse(localStorage.getItem('token'));
    const params = {
      userId: user.id,
      processList: this.currentProcessList.id
    }
    
    this.http.get('user_process_list:interview', params)
      .subscribe(
        (result: any) => {
          
          if(result.type === 'OK')
            this.interviewSelected = result.data;          
        },
        err => this.errorReport.showMessage(err)
      );


  }*/

  saveUserInterview(interview, accept) {
    /*if(interview.id === this.interviewSelected.id)
      return;*/

    if(!accept) {
      if(!confirm('Tem certeza que quer rejeitar essa entrevista, essa ação nao poderá ser desfeita?'))
        return;
    }
      
    const user: any = JSON.parse(localStorage.getItem('token'));
    const params = {
      userId: user.id,
      interview: interview.id,
      accept
    }
    
    this.http.save('user_process_list:interview', params)
      .subscribe(
        (result: any) => {
          if(result.type === 'OK') {
            this.http.save('onsignal:getCompanySing', {id: this.currentProcessList.company})
              .subscribe(
                (result: any) => {
                  if (result.type === 'OK') {
                    //console.log(result);
                    const processname = this.currentProcessList.name;
                    const signatureIds = [result.data[0].signature_id]; // Extrai os signature_ids
                    const notification_for_all = null;
                    const fullname = user.firstname+' '+user.lastname;
                    let title = '';
                    let message = '';
                    
                    if(accept){
                      title = 'Entrevista Aceita';
                      message = this.oneSignalService.listMessage(3, fullname, processname );
                    }else{
                      title = 'Entrevista Recusada';
                      message = this.oneSignalService.listMessage(4, fullname, processname );
                    }        
                    
                    // Envia os dados para a função do backend que lida com as notificações
                    this.oneSignalService.sendNotification(signatureIds, title, message, notification_for_all)
                    .subscribe(
                      (result: any) => {
                        if (result.type === 'OK') {
                          this.oneSignalService.listNotification();
                        } else {
                          console.error('Erro ao enviar notificação da entrevista sobre o processo seletivo');
                        }
                      },
                      err => {
                        console.error('Erro ao enviar notificação da entrevista ao recrutador', err);
                        this.errorReport.showMessage(err);
                      }
                    );
                  } else {
                    console.error('Erro ao enviar notificação');
                  }
                },
                err => this.errorReport.showMessage(err)
              )
            this.snackbar.open('Sua resposta foi enviada com sucesso!', 'OK', { duration: 3000 });
            this.communicationService.triggerReload(); // Dispara o evento
            this.getInterviews();
          }
        },
        err => this.errorReport.showMessage(err)
      );

  }

  getDiasSemana(dias: string): string {
    const diasSemana = {
      'monday': 'segunda-feira',
      'tuesday': 'terça-feira',
      'wednesday': 'quarta-feira',
      'thursday': 'quinta-feira',
      'friday': 'sexta-feira',
      'saturday': 'sábado',
      'sunday': 'domingo'
    };

    const diasArray = dias.split(',').map(dia => dia.trim().toLowerCase());
    const diasTraduzidos = diasArray.map(dia => diasSemana[dia]);

    return diasTraduzidos.join(', ');
  }

  getDiaSemana2(dia: string): string {
    const diasSemana = {
      'monday': 'segunda-feira',
      'tuesday': 'terça-feira',
      'wednesday': 'quarta-feira',
      'thursday': 'quinta-feira',
      'friday': 'sexta-feira',
      'saturday': 'sábado',
      'sunday': 'domingo'
    };
  
    return diasSemana[dia];
  }

  formatarHora(hora: string): string {
    if (!hora) {
      return '';
    }
    const [horas, minutos] = hora.split(':');
    return `${horas.padStart(2, '0')}:${minutos.padStart(2, '0')}`;
  }

  diaEstaPresente(dia: string): boolean {
      return this.currentProcessList.daysWeek.includes(dia.toLowerCase());
  }
 
  formatSalaryForEdit(salary: string): string {
    if (!salary) {
      return '';
    }

    // Remover formatação existente
    const cleanValue = salary.replace(/[^\d,]/g, '');

    // Remover vírgula
    const noCommaValue = cleanValue.replace(',', '');

    let formattedValue = '';

    // Verificar se o valor tem mais de 3 dígitos para adicionar separadores
    if (noCommaValue.length > 3) {
      const integerPart = noCommaValue.slice(0, -2); // Parte inteira sem os dois últimos dígitos
      const decimalPart = noCommaValue.slice(-2); // Últimos dois dígitos como parte decimal
      formattedValue = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + decimalPart;
    } else {
      formattedValue = noCommaValue + ',00'; // Se tiver menos de 3 dígitos, adicionar ',00' para decimal
    }

    return formattedValue;
  }

  formatMoneyInput(event: any): void {
    let value = event.target.value;

    // Remover qualquer formatação existente
    value = value.replace(/\D/g, '');

    // Adicionar vírgula após o terceiro caractere
    if (value.length > 3) {
      const beforeDecimal = value.slice(0, -2);
      const afterDecimal = value.slice(-2);
      value = beforeDecimal + ',' + afterDecimal;
    }

    // Formatar o valor inserindo o ponto como separador de milhares
    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Atualizar o valor no campo de entrada
    event.target.value = value;
  }

  formatTime(time: string): string {
    return time.substring(0, 5); // Retorna apenas os primeiros 5 caracteres (HH:mm)
  }

  checkDateAndConfirm(event: MouseEvent, dateStart: string, timeStart: string): void {
    const currentDate = new Date(); // Data e hora atual
  
    // Quebra a string "2025-01-22" em ano, mês e dia
    const [year, month, day] = dateStart.split('-').map(Number);
  
    // Quebra a string "12:00" em hora e minuto
    const [hour, minute] = timeStart.split(':').map(Number);
  
    // Cria a data ajustada (mês é zero-indexado, hora e minuto são considerados)
    const startDate = new Date(year, month - 1, day, hour, minute);
    
    // console.log('currentDate', currentDate);
    // console.log('startDate', startDate);

    // Compara as datas e horas
    if (currentDate < startDate) {
      const proceed = confirm('A entrevista ainda não começou. Deseja continuar mesmo assim?');
      if (!proceed) {
        event.preventDefault(); // Impede o redirecionamento
      }
    }
  }
  
  addOneHour(start: string): string {
    const date = new Date(start);
    date.setHours(date.getHours() + 1);
    return date.toISOString().slice(0, 19);
  }

  handleEventClick(arg: EventClickArg) {
    
    const interview = arg.event.extendedProps;
  
    const dialogRef = this.dialog.open(UserProcessListInterviewDialogComponent, {
      data: {
        titulo: arg.event.title,
        ...interview
      },
      width: '500px'
    });
  
    dialogRef.afterClosed().subscribe((result: boolean | undefined) => {
      if (result === true || result === false) {
        this.saveUserInterview(interview, result);
      }
    });
  }

  irParaData(data: Date) {
    this.calendarComponent.getApi().gotoDate(data);
  }

  abrirEntrevista(event: any) {
    // 1. Vai para a data da entrevista
    this.irParaData(event.start);
  
    // 2. Abre o modal com os dados da entrevista
    const dialogRef = this.dialog.open(UserProcessListInterviewDialogComponent, {
      data: {
        titulo: event.title,
        ...event.extendedProps
      },
      width: '500px'
    });
  
    dialogRef.afterClosed().subscribe((result: boolean | undefined) => {
      if (result === true || result === false) {
        this.saveUserInterview(event.extendedProps, result);
      }
    });
  }
  
  
}